/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAssessmentResponseData } from './genericApiResponseAssessmentResponseData';
import type { GenericApiResponseAssessmentResponseMessage } from './genericApiResponseAssessmentResponseMessage';
import type { GenericApiResponseAssessmentResponsePagination } from './genericApiResponseAssessmentResponsePagination';
import type { GenericApiResponseAssessmentResponseError } from './genericApiResponseAssessmentResponseError';

export interface GenericApiResponseAssessmentResponse {
  data?: GenericApiResponseAssessmentResponseData;
  message?: GenericApiResponseAssessmentResponseMessage;
  pagination?: GenericApiResponseAssessmentResponsePagination;
  error?: GenericApiResponseAssessmentResponseError;
  statusCode?: number;
}
